import { useState, useEffect, useRef } from 'react';
import React from 'react';
import { Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import EmbeddedVideoListing from '../../../../constants/CasestudyVideoListing';
import { useParams } from 'react';

import * as styles from './Diy.module.css';

const Branching = ({ formData, handleInputChange }) => {
  return (
    <>
      <Form.Group
        className={styles.persona}
        controlId="Branching1"
        key="Branching1"
      >
        <Form.Label className={styles.diyLabel}>Branching</Form.Label>
        <Form.Control
          name="Branching1"
          type="text"
          className={styles?.name}
          placeholder="Branch Label 1"
          value={formData?.Branching1}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
      <Form.Group
        className={styles.persona}
        controlId="Branching2"
        key="Branching2"
      >
        <Form.Control
          name="Branching2"
          type="text"
          className={styles?.name}
          placeholder="Branch Label 2"
          value={formData?.Branching2}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
      <Form.Group
        className={styles.persona}
        controlId="Branching3"
        key="Branching3"
      >
        <Form.Control
          name="Branching3"
          type="text"
          className={styles?.name}
          placeholder="Branch Label 3"
          value={formData?.Branching3}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
    </>
  );
};

export default Branching;
